import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-location-upload-dialog',
  templateUrl: './location-upload-dialog.component.html',
  styleUrls: ['./location-upload-dialog.component.scss']
})
export class LocationUploadDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LocationUploadDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}
